<template>
  <transition name="fade">
    <div v-if="show" class="modal is-active">
      <div class="modal-background"></div>
      <div class="modal-card">
        <header class="modal-card-head">
          <p class="modal-card-title">Select a Rubric Option and Score</p>
          <button @click="close()" class="delete"></button>
        </header>
        <section class="modal-card-body">

          <div class="field">
            <label class="label">Rubric Element</label>
            <div class="control">
              <div class="select">
                <select @change="$emit('change', element)" v-model='element'>
                  <option value="0" selected disabled>--select--</option>
                  <option v-for="el in rubricElements" :value="el.id">{{ el.title }}</option>
                </select>
              </div>
            </div>
          </div>

          <div class="field">
            <label class="label" :class="element === 0 && 'is-disabled'">Rubric Score</label>
            <div class="control">
              <div class="select">
                <select :disabled="element === 0" v-model='descriptor'>
                  <option value="0" selected>No Score</option>
                  <option v-for="descriptor in descriptors" :value="descriptor.id">{{ descriptor.score }} - {{ descriptor.title }}</option>
                </select>
              </div>
            </div>
          </div>

        </section>
        <footer class="modal-card-foot">
          <section class="button-container">
            <a @click="close()" class="button">Cancel</a>
            <button @click="addTag()"
              :disabled="element === 0"
              :class="loading && 'is-loading'"
              class="button is-primary">
              Add Rubric Tag
            </button>
          </section>
        </footer>
      </div>
    </div>
  </transition>
</template>

<script>
import store from '../store.js'

export default {
  name: 'AddRubricTagModal',
  props: {
    show: {
      type: Boolean,
      required: true,
    },
    commentID: {
      type: Number,
      required: true,
    },
    cycleID: {
      type: Number,
      required: false,
    },
    videoID: {
      type: Number,
      required: true,
    },
  },
  computed: {
    rubricElements () {
      return store.state.rubricElements.sort((a, b) => a.title.localeCompare(b.title))
    },
    descriptors () {
      const element = this.rubricElements.find(x => x.id === this.element)
      if (element == null) return []
      return element.descriptors
    },
    loading () {
      return store.state.addingRubricEementtoComment
    },
  },
  methods: {
    close () {
      this.$emit('close')
    },
    addTag () {
      const { commentID, element, descriptor, cycleID, videoID } = this
      store.dispatch('addRubricOptiontoComment', { cycleID, videoID, commentID, element, descriptor })
      .then(() => this.close())
    },
  },
  data () {
    return {
      element: 0,
      descriptor: 0,
    }
  },
}
</script>

<style lang="scss" scoped>

.fade-enter-active, .fade-leave-active {
  transition: all .1s;
}

.fade-enter, .fade-leave-to {
  opacity: 0;
}

.button-container {
  display: flex;
  justify-content: space-between;
  width: 100%;
}

.modal-card-body {
  display: flex;
  justify-content: center;
}

@media screen and (min-width: 769px), print {
  .modal-content, .modal-card {
    width: 450px;
  }
}

.select,
select {
  width: 100%;
}

.field:not(:last-child) {
  margin-right: 1rem;
}

.field {
  width: 100%;
}

@import '../_variables.scss';

.is-disabled {
  color: $disabled-gray;
}
</style>



// WEBPACK FOOTER //
// AddRubricTagModal.vue?0a4fd5b6